<template>
    <div class="subject law">
        <div class="law-wrap">
            <div v-if="isShowRoleSelect" class="select-wrap">
                <div v-if="isLoading">
                    <veui-loading
                        :loading="isLoading"
                        class="loading"
                        ui="strong l"
                    >
                        加载中
                    </veui-loading>
                </div>
                <template v-else>
                    <!-- 律所认证 -->
                    <law-firm-authentication
                        v-if="isShowBjh"
                        :status="lawBjhStatus"
                        :sub-type="subType"
                        :uk="userInfo.uk"
                    ></law-firm-authentication>
                    <!-- 律所认证表单 -->
                    <div v-else-if="isShowFirmForm">
                        <div class="back-title-box">
                            <div class="back" @click="goBack">返回</div>
                            <div class="line"></div>
                            <div>更改入驻类型</div>
                        </div>
                        <div class="firm-form">
                            <intro-management
                                :profile="firmInfo"
                                :is-certification="true"
                                @submit="submitSucc"
                            />
                        </div>
                    </div>
                    <!-- 法律-选择角色 -->
                    <law-role-select
                        v-else
                        @selectLawFirm="clickLawFirm"
                        @selectLawyer="clickLawyer"
                    ></law-role-select>
                </template>
            </div>
            <!-- 律师认证 -->
            <template v-else>
                <material></material>
            </template>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import material from '../../pages/material/views/index';
import LawRoleSelect from './law/lawRoleSelect.vue';
import LawFirmAuthentication from './law/lawFirmAuthentication.vue';
import {Loading} from 'veui';
import infroManagement from '../../pages/firm-intro/components/intro-management.vue';
import Vue from 'vue';

export default {
    name: 'subject',
    components: {
        material,
        'law-role-select': LawRoleSelect,
        'law-firm-authentication': LawFirmAuthentication,
        'veui-loading': Loading,
        'intro-management': infroManagement
    },
    computed: {
        ...mapState({
            isLogin: state => state.Menu.isLogin,
            userInfoStatus: state => state.Menu.userInfoStatus,
            userType: state => state.Menu.userType,
            firstApprove: state => state.Menu.firstApprove,
            bjhInfo: state => state?.lawStore?.bjhInfo || {},
            userInfo: state => state?.lawStore?.userInfoNew || {},
            vipInfo: state => state.lawStore?.vipInfo || {}
        })
    },
    data() {
        return {
            sfrom: 'law',
            isShowRoleSelect: true, // 是否展示法律的角色选择
            lawBjhStatus: '', // 法律角色百家号审核状态
            isShowBjh: false, // 是否展示百家号认证页面
            isSubmit: false,
            isLoading: true,
            businessId: '', // 律所id
            subType: '', // 百家号类型，企业(company 或 other)还是个人等
            isShowFirmForm: false, // 显示律所表单
            firmInfo: {} // 律所信息
        };
    },
    mounted() {
        if (+this.isLogin === 1) {
            this.getLawFirmStatus();
            this.observeSubmitSuccess();
            if (this.$route.query && this.$route.query.qcno) {
                this.isShowRoleSelect = false;
            }
            if (
                (+this.userType === 0 && +this.userInfoStatus === 0)
                || ((+this.userType !== 0 && +this.userType !== 3) && this.firstApprove === 0)
            ) {
                const urlName = this.$router.history.current.name;
                urlName !== 'filldata'
                    && this.$router.push({
                        name: 'filldata'
                    });
                return;
            }
            if (+this.userInfoStatus === 10 && +this.userType === 0) {
                const urlName = this.$router.history.current.name;
                urlName !== 'LawVerifyGuide'
                    && this.$router.push({
                        name: 'LawVerifyGuide'
                    });
                return;
            }
            let map = {
                0: 'lawinfo', // 律师
                1: 'lawTpInfo', // 代理商
                2: 'firmintro', // 律所
                3: 'lawTpInfo'// 代理商
            };
            this.$router.push({
                name: map[+this.userType] || 'lawclues'
            });
        }
        else {
            this.$router.push({
                name: 'login'
            });
        }
    },
    destroyed() {
        // 在组件生命周期结束的时候销毁监听
        window.removeEventListener('message', this.onMessage);
    },
    methods: {
        ...mapActions({
            getUserInfoNew: 'lawStore/getUserInfoNew',
            updateMenu: 'Menu/updateMenu',
            init: 'Menu/init'
        }),
        // 埋点主体类型映射
        subjectType(type) {
            let map = {
                company: 'enterprise',
                personal: 'personal'
            };
            return map[type];
        },

        /**
         * 点击律所按钮
         */

        clickLawFirm() {
            // 缓存点击律所按钮动作，下次进入时直接进到下一个页面
            let uk = this.userInfo.uk;
            uk && localStorage.setItem('clickFirmBtn', JSON.stringify({
                [uk]: 1
            }));
            this.getLawFirmStatus();
        },

        /**
         * 点击律师按钮
         */

        clickLawyer() {
            this.isShowRoleSelect = false;
        },

        /**
         * 获取查询是否有律所身份
         * userType: -1: 无律师角色 0：个人律师  1：代理  2: 律所
         */

        getLawFirmStatus() {
            this.$http
                .get('/bp/api/business/getroleinfo', {})
                .then(res => {
                    let data = res?.data || {};
                    this.businessId = data.businessInfo?.id || '';
                    this.lawBjhStatus = data.bjhInfo?.status || '';
                    this.subType = data.bjhInfo?.subType || '';
                    let uk = this.userInfo.uk;
                    let clickFirmBtnInfo = JSON.parse(localStorage.getItem('clickFirmBtn')) || {};
                    // 点击过律所按钮
                    if (clickFirmBtnInfo[uk]) {
                        // 百家号认证通过
                        if ((this.subType === 'company' || this.subType === 'other')
                            && this.lawBjhStatus === 'pass'
                        ) {
                            // 商户 id 为空，进入律所认证表单填写
                            if (!this.businessId) {
                                this.isShowFirmForm = true;
                                this.getProfile();
                            }
                            else {
                                this.$router.push({
                                    name: 'lawclues'
                                });
                            }
                            return;
                        }
                        this.isShowBjh = true;
                    }
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        /**
         * 监听百家号信息提交成功
         */

        observeSubmitSuccess() {
            document && (document.domain = 'baidu.com');
            window && window.addEventListener('message', this.onMessage);
        },

        onMessage(e) {
            const {data = {}} = e || {};
            // 来自注册模块的message
            if (data?.messageSource === 'register') {
                let myIframe = document.getElementById('bjh-iframe');
                // iframe ready
                if (data?.type === 'onIframeReady') {
                    const config = {
                        appKey: 'lvlin',
                        showHeader: false,
                        showFooter: false,
                        baseConf: {
                            avatar: {
                                label: '律所头像'
                            },
                            name: {
                                label: '律所名称'
                            },
                            wishes: {
                                label: '律所简介',
                                maxLength: 40,
                                placeholder: '一句话介绍你的律所（10-40个字）',
                                desc: '10-40个字，简明扼要地展示您的内容风格，让读者快速了解您的律所'
                            }
                        },
                        skipChooseType: true,
                        defaultChoosenType: 'company'
                    };
                    myIframe?.contentWindow?.postMessage(config, '*');
                    return;
                }
                if (data?.type === 'onResize') {
                    const height = data?.data?.height || '1000px';
                    myIframe.setAttribute('height', height);
                }
                if (data?.type === 'onPageChange') {
                    if (
                        data?.payload?.from === 'pravicyInfo'
                        && data?.payload?.to === 'baseInfo'
                    ) {
                        myIframe.setAttribute('height', '872px');
                    }
                }
                // 提交成功
                if (data?.type === 'onSuccess') {
                    this.$log
                        && this.$log.send({
                            type: 'clk',
                            value: 'bjh-submit',
                            page: 'filldata',
                            ext: {
                                businessId: this.businessId
                            }
                        });
                    // 提交完成后的处理
                    this.getLawFirmStatus();
                }
            }
        },
        getProfile() {
            this.$http.get('/bp/api/business/getprofile', {
                params: {
                    businessId: this.businessId
                }
            }).then(res => {
                if (!res || +res.code !== 0 || !res.data) {
                    return;
                }
                let lastFirmInfo = JSON.parse(localStorage.getItem('firmInfo')) || {};
                let uk = this.userInfo.uk;
                let profileCache = lastFirmInfo[uk] || {};
                this.firmInfo = Object.assign(
                    profileCache,
                    res.data.profile
                );
            }).catch(err => {
                this.$normalizeResponseError(err);
            });
        },

        /**
         * 律所信息提交成功，跳转到律所简介页面
         */

        submitSucc() {
            setTimeout(() => {
                this.getUserInfoNew().then(res => {
                    if (res) {
                        this.$toast.success('您已成功入驻');
                        // 初始化菜单
                        this.updateMenu({userInfo: res, vipInfo: this.vipInfo});
                        this.init(Vue.prototype.bend);
                        this.$router.replace({
                            name: 'firmintro'
                        });
                    }
                });
            }, 1000);
        },

        /**
         * 返回上一步
         */

        goBack() {
            this.isShowFirmForm = false;
            let uk = this.userInfo.uk;
            if (!uk) {
                return;
            }
            let clickFirmBtnInfo = JSON.parse(localStorage.getItem('clickFirmBtn'));
            clickFirmBtnInfo[uk] = 0;
            localStorage.setItem('clickFirmBtn', JSON.stringify({
                ...clickFirmBtnInfo
            }));
        }
    }
};
</script>

<style scoped lang="less">
.subject {
    padding-top: 72px;

    .statement {
        text-align: center;
        color: #f60;
        margin: 60px 0 10px;
    }

    .law-wrap {
        margin: 18px auto 0;
        display: flex;
        justify-content: center;

        .select-wrap {
            width: 1128px;
            background: #fff;
            box-shadow: 0 6px 14px 0 rgba(227, 233, 237, .35);
            border-radius: 8px;
            text-align: center;

            .loading {
                height: 400px;
            }
        }

        .firm-form {
            padding-bottom: 50px;

            /deep/.title {
                font-family: PingFangSC-Medium;
                font-size: 18px;
                padding: 30px 0 30px 30px;
                color: #000;
                font-weight: 500;
                display: flex;
                align-items: center;

                .tip {
                    margin-left: 6px;
                    height: 16px;
                }
            }
        }

        .back-title-box {
            display: flex;
            align-items: center;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            line-height: 16px;
            color: #333;
            padding: 30px 0 0 30px;

            .back {
                position: relative;
                padding-left: 12px;
                cursor: pointer;

                &::before {
                    content: "";
                    position: absolute;
                    height: 12px;
                    width: 10px;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    background: url(https://lvlin-base.cdn.bcebos.com/bend/back-icon.png) no-repeat center center / 100% 100%;
                }
            }

            .line {
                width: 1px;
                height: 10px;
                background: #9d9d9d;
                margin: 0 12px;
            }
        }
    }

    .bjh-tip {
        color: #f39c12;
        text-align: center;
    }

    .main {
        margin: 60px auto 0 auto;
        display: flex;
        justify-content: center;

        .box {
            width: 228px;
            font-size: 14px;
            margin-right: 24px;
            border: 1px solid #ececec;
            padding: 24px;
            border-radius: 3px;
            cursor: pointer;
            text-align: center;
            transition: .48s box-shadow ease;
            position: relative;
            box-sizing: border-box;
            height: 382px;

            .btn {
                visibility: hidden;
                position: absolute;
                left: 50%;
                bottom: 20px;
                margin-left: -50px;
                width: 100px;
            }

            &:last-child {
                margin-right: 0;
            }

            &:hover {
                box-shadow: 0 2px 20px rgba(0, 0, 0, .1);

                .btn {
                    display: inline-block;
                    visibility: visible;
                }
            }

            .title {
                font-size: 16px;
                color: #3c75f5;
            }

            .desc {
                margin-top: 20px;
                font-size: 14px;
                height: 84px;
                text-align: left;
            }

            .icon {
                width: 42px;
                height: 42px;
                margin: 0 auto 20px;
                background: url("../../assets/img/choose.png") no-repeat 0 0;
                background-size: 100%;
            }

            .personal {
                background-position: 0 0;
            }

            .organizations {
                background-position: 0 -192px;
            }

            .company {
                background-position: 0 -96px;
            }

            .media {
                background-position: 0 -48px;
            }

            .government {
                background-position: 0 -144px;
            }

            .regdata {
                dt {
                    color: #666;
                    padding-bottom: 10px;
                    position: relative;
                    width: 90px;
                    margin: 0 auto;

                    &::after {
                        size: 30px 1px;
                        position: absolute;
                        left: -35px;
                        top: 10px;
                        content: "";
                        display: block;
                        background-color: #ddd;
                    }

                    &::before {
                        size: 30px 1px;
                        position: absolute;
                        right: -35px;
                        top: 10px;
                        content: "";
                        display: block;
                        background-color: #ddd;
                    }
                }

                dd {
                    text-align: left;
                    color: #9d9d9d;
                    position: relative;
                    line-height: 1.6;
                    text-indent: 1em;

                    &::before {
                        content: "·";
                        position: absolute;
                        left: -14px;
                        top: -13px;
                        display: block;
                        font-size: 30px;
                    }
                }
            }
        }
    }

    .catch {
        text-align: center;
        font-size: 18px;
        line-height: 1.8;

        p {
            padding-top: 32px;
        }
    }
}

.subject.law {
    padding: 0;
}
</style>
